import styled from 'styled-components';

import { useBoolean } from '@dreryk/react-common';
import { AddCircleIcon, Link, LinkSize } from '@dreryk/react-components';

import { NoteTextarea, NoteValue } from '~libs.desktop.shared.appointment';

import { appointmentsTranslationKeys } from '../../../../../translations';
import { AppointmentFormController } from '../AppointmentForm.types';

const StyledLink = styled(Link)`
   gap: 1px;
`;

StyledLink.displayName = 'StyledLink';

type AppointmentNoteProps = Pick<AppointmentFormController, 'register'> & {
   readonly note: NoteValue;
};

export const AppointmentNote = (props: AppointmentNoteProps): JSX.Element => {
   const [{ setTrue: showNoteTextarea }, noteTextareaShowed] = useBoolean(Boolean(props.note));

   if (noteTextareaShowed) {
      return <NoteTextarea register={props.register} label={appointmentsTranslationKeys.create.form.note.label} />;
   }

   return (
      <StyledLink
         onClick={showNoteTextarea}
         testId={'showNoteTextarea'}
         size={LinkSize.NORMAL}
         paddingTop
         icon={<AddCircleIcon />}
         label={appointmentsTranslationKeys.create.form.note.action}
      />
   );
};
